import Header from '../components/Header/Header';
import Hero from "../components/Hero/Hero";
import About from "../components/About/About";
import Banner from "../components/Banner/Banner";
import Services from "../components/Services/Services";
import Cases from "../components/Cases/Cases";
import Footer from "../components/Footer/footer";
import Feedback from "../components/Feedback/Feedback";

const HomePage = () => {
  return (
    <div style={{ paddingTop: '80px' }}>
      <Header />
      <Hero />
      <div id="about">
        <About />
      </div>
      <Banner />
      <div id="services">
        <Services />
      </div>
      <div id="cases">
        <Cases />
      </div>
      <div id="feedback">
        <Feedback />
      </div>
      <Footer />
    </div>
  );
};

export default HomePage;